import {DeliveryMethod} from '../consts/restaurantConsts';
import {Address, LocalAddress} from '../store/models';

// sa = System Announcement
export const createSaKey = (address: Address | LocalAddress | undefined, deliveryMethod: DeliveryMethod): string => {
  if (!address) {
    return '';
  }

  const {longitude, latitude, cityId} = address;
  return `${longitude},${latitude},${cityId},${deliveryMethod}`;
};
